import AppConfig from '@config';
import {
  APILoadingStatus,
  APIProvider,
  Map as GoogleMap,
  Marker,
  useApiLoadingStatus,
} from '@vis.gl/react-google-maps';
import { Linking, View, ViewProps } from 'react-native';

type MapProps = ViewProps & { latitude: number; longitude: number };

const MapContent = ({ latitude, longitude }: MapProps) => {
  const status = useApiLoadingStatus();
  const url = `https://maps.google.com/?q=${latitude},${longitude}`;

  if (
    status === APILoadingStatus.FAILED ||
    status === APILoadingStatus.AUTH_FAILURE
  ) {
    return <a href={url}>Google Maps</a>;
  }

  return (
    <GoogleMap
      key={`${latitude},${longitude}`}
      style={{ width: '100%', height: '100%' }}
      defaultCenter={{ lat: latitude, lng: longitude }}
      defaultZoom={16}
      gestureHandling="cooperative">
      {/* Keep the existing marker behavior without requiring a new Cloud map ID. */}
      <Marker
        position={{ lat: latitude, lng: longitude }}
        onClick={() => Linking.openURL(url)}
      />
    </GoogleMap>
  );
};

export const Map = ({
  latitude = 34.2428895825304,
  longitude = -116.91506088827596,
  ...viewProps
}: MapProps) => {
  if (
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude) ||
    Math.abs(latitude) > 90 ||
    Math.abs(longitude) > 180
  ) {
    return <View {...viewProps} />;
  }

  const apiKey = AppConfig.Settings.GOOGLE_API_KEY;

  return (
    <View {...viewProps}>
      {apiKey ? (
        <APIProvider apiKey={apiKey}>
          <MapContent latitude={latitude} longitude={longitude} />
        </APIProvider>
      ) : (
        <a href={`https://maps.google.com/?q=${latitude},${longitude}`}>
          Google Maps
        </a>
      )}
    </View>
  );
};

export default Map;
